import SocialMediaBarElement from './SocialMediaBar.element.jsx'

if (!window.customElements.get('social-media-bar')) {
  window.customElements.define('social-media-bar', SocialMediaBarElement)
}
